<template>
  <v-card>
    <v-card-title>
      <div class="headline">
        Снятие счетчика с точки учёта
      </div>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-col cols="12">
            <v-menu
              v-model="operDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="operDate"
                  label="Дата операции"
                  readonly
                  @blur="operDateVal = parseDate(operDate)"
                />
              </template>
              <v-date-picker
                v-model="operDateVal"
                no-title
                scrollable
                locale="ru-RU"
                @input="operDateMenu = false"
              />
            </v-menu>
        </v-col>
        <v-col cols="12">
          <v-text-field
              v-model="counter_oper.comment"
              label="Причина снятия счётчика"
              required
          />
        </v-col>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="blue darken-1"
        text
        @click.native="saveChanges"
      >
        Снять счётчик
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click.native="cancelEditing()"
      >
        Отмена
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'PointCounterTakeOff',
  props: {
    counterData: {}
  },
  data () {
    return {
      operDateMenu: false,
      operDateVal: null,
      operDate: null,
      counter_oper: {
        'operation_date': null,
        'comment': null
      }
    }
  },
  watch: {
    operDateVal () {
      this.operDate = this.formatDate(this.operDateVal)
      this.counter_oper.operation_date = this.operDateVal
    }
  },
  mounted () {
    var currentDate = new Date()
    this.operDateVal = this.parseDate(currentDate.getDate() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear())
  },
  methods: {
    cancelEditing: function () {
      this.$emit('cancel')
    },
    saveChanges () {
      this.axios.post(`/api/point_counter/${this.counterData.counter_id}/take_off/`, this.counter_oper)
        .then(() => {
          this.$emit('edited')
        })
        .catch((err) => {
          this.$emit('editError', err.response.data)
        })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/points/counters/PointCounterTakeOff.vue